import ContactFormSubject from "./ContactFormSubject"

export default class ContactFormConfiguration {
    public subjects : ContactFormSubject[] = [];
    public questionTitle : string = "";
    public questionDescription : string = "";
    public informationTitle : string = "";
    public informationDescription : string = "";
    public subjectLabel : string = "";
    public subjectPlaceholder : string = "";
    public questionLabel : string = "";
    public questionPlaceholder : string = "";
    public attachmentMaxSize: number = 7000000; //MB
    public attachmentToLargeValidationMessage: string = "";
    public attachmentLabel : string = "";
    public attachmentExtraInfo : string = "";
    public attachmentAddFileLabel : string = "";
    public attachmentDragFileLabel : string = "";
    public alreadyCustomerButton : string = "";
    public notYetCustomerButton : string = "";
    public rszNumberLabel : string = "";
    public rszNumberPlaceholder : string = "";
    public rszNumberInfo : string = "";
    public rszNumberFindPictureButtonText : string = "";
    public rszNumberFindPictureUrl : string = "";
    public customerNumberLabel : string = "";
    public customerNumberPlaceholder : string = "";
    public customerNumberAdditionalInformation : string = "";
    public dayOfBirthLabel : string = "";
    public dayOfBirthPlaceholder : string = "";
    public genderLabel : string = "";
    public genderValues : string[] = [];
    public firstnameLabel : string = "";
    public firstnamePlaceholder : string = "";
    public lastnameLabel : string = "";
    public lastnamePlaceholder : string = "";
    public emailLabel : string = "";
    public emailPlaceholder : string = "";
    public telephoneLabel : string = "";
    public telephonePlaceholder : string = "";
    public postalCodeLabel : string = "";
    public postalCodePlaceholder : string = "";
    public consentLabel : string = "";
    public sendButton : string = "";
    public redirectPageURL : string = "";
    public privacyPageURL : string = "";
    public privacyPageLabel : string = "";
    public fileUploadAllowedFormatsLabel : string = "";
}